function Pin3(props: iconProps) {
  const fill =
    (props.fill === 'ink-blue' ? '#0E1647' : props.fill) || 'currentColor'
  const secondaryfill = props.secondaryfill || 'currentColor'
  const strokewidth = props.strokewidth || 1
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'location'

  return (
    <svg
      height={height}
      width={width}
      viewBox='0 0 16 16'
      xmlns='http://www.w3.org/2000/svg'
      className={props?.className}
    >
      <title>{title}</title>
      <g fill={fill}>
        <path
          d='M13.5,6c0,4.5-5.5,9.5-5.5,9.5S2.5,10.5,2.5,6a5.5,5.5,0,0,1,11,0Z'
          fill='none'
          stroke={fill}
          strokeLinecap='square'
          strokeWidth={strokewidth}
        />
        <circle
          cx='8'
          cy='6'
          fill='none'
          r='1.5'
          stroke={secondaryfill}
          strokeLinecap='square'
          strokeWidth={strokewidth}
        />
      </g>
    </svg>
  )
}

export default Pin3
